import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { staticURL } from 'core/url';
import { inWhitelabel, getWhitelabelConfig } from 'core/whitelabel';
import { clientStore } from 'apps/client/app';
import { modalStore } from 'apps/modals/app';
import { AccessForm } from 'apps/profile/accessForm';

import { SignInForm } from 'apps/signIn/views/signInForm';
// import { FablabsForm } from 'apps/signIn/views/fablabsForm';
import { WhiteLabelForm } from 'apps/signIn/views/whitelabelForm';
import { SingleOAuthForm } from 'apps/signIn/views/singleOAuthForm';
import { ResetPasswordModal } from 'apps/signIn/resetPassword/index';

import { withNamespaces } from 'react-i18next';

import Button from 'components/Button';
import Image from 'components/Image';
import {
  MainSignInPageWrapper,
  ImageWrapper,
  GoBackWrapper,
} from 'apps/signIn/styles';

@withNamespaces()
@observer
export class SignInPage extends React.Component {
  UNSAFE_componentWillMount() {
    this.appManager = clientStore.context.get('signInAppManager');
  }

  clickNoAccount() {
    clientStore.routerStore.navigate('home.signUp', {
      next: clientStore.next(),
    });
  }

  clickForgotPassword() {
    modalStore.SetModalComponent(ResetPasswordModal);
  }

  clickRequestInvite() {
    modalStore.SetModalComponent(AccessForm);
  }

  render() {
    let FormComponent = SignInForm;
    if (inWhitelabel()) {
      if (getWhitelabelConfig().onlyOAuthSignIn) {
        FormComponent = SingleOAuthForm;
      } else {
        FormComponent = WhiteLabelForm;
      }
    }
    return (
      <MainSignInPageWrapper>
        <GoBackWrapper>
          <Button
            outline
            variant='minimal'
            icon='close_small'
            size='small'
            onClick={() => window.history.go(-1)}
          />
        </GoBackWrapper>
        <ImageWrapper>
          <Image
            src={staticURL('assets/gridImages/grid_sighin.svg')}
            alt='Grid image'
          />
        </ImageWrapper>
        <FormComponent
          form={this.appManager.signInApp.form}
          title='Log in'
          handleForgotPassword={this.clickForgotPassword}
          handleSignIn={this.appManager.signInApp.SignIn}
          handleNoAccount={this.clickNoAccount}
          handleRequestInvite={this.clickRequestInvite}
        />
      </MainSignInPageWrapper>
    );
  }
}

SignInPage.propTypes = {
  t: PropTypes.func,
};
